import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TrainingSectionComponent } from 'app/training-and-inductions/trainee/training-section/training-section.component';
import Swal from 'sweetalert2';

@Injectable()
export class TrainingAndInductionsGuard implements CanDeactivate<TrainingSectionComponent> {

  canDeactivate(
    component: TrainingSectionComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {

    if (this.removeRouteParams(nextState.url) === '/worker/training//section/') {
      return true;
    }

    if (component.canLeave) {
      return true;
    }

    return Swal.fire({
      title: 'Are you sure you want to leave? <br> You have unsaved changes',
      type: 'warning',
      showCancelButton: true,
      customClass: {
        confirmButton: 'confirm-danger',
      },
      confirmButtonText: 'Yes, leave',
    }).then((result) => {
      if (result.value) {
        return true;
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return false;
      } else {
        return true;
      }
    });
  }

  private removeRouteParams(url: string): string {
    const semicolonIndex = url.indexOf(';');
    const questionIndex = url.indexOf('?');
    const endIndex = Math.min(semicolonIndex > -1 ? semicolonIndex : url.length, questionIndex > -1 ? questionIndex : url.length);
    return url.slice(0, endIndex).replace(/\d+/g, '');
  }
}
